import React, { useState, useEffect } from "react";

const Item = ({
  img,
  title,
  handleAdd,
  product,
  handleRemove,
  values,
  havePeruk,
  haveHarkava,
  isServices,
}) => {
  const [numbersOfItems, setNumbersOfItems] = useState(0);
  const [peruk, setPeruk] = useState(false);
  const [harkava, setHarkava] = useState(false);
  const [touch, setTouch] = useState(false);

  const addItem = (e) => {
    if (!touch) {
      setTouch(true);
    }
    e.preventDefault();
    setNumbersOfItems(numbersOfItems + 1);
    // const item = e.target.parentElement.parentElement ;
    // item.classList.add('paidServiceSquareDivActive')
  };

  const lessItem = (e) => {
    if (!touch) {
      setTouch(true);
    }
    e.preventDefault();
    if (numbersOfItems > 0) {
      setNumbersOfItems(numbersOfItems - 1);
    }
  };

  useEffect(() => {
    if (touch) {
      if (numbersOfItems > 0) {
        // handleAdd({ ...product, title, number: numbersOfItems });
        handleAdd({
          ...product,
          title,
          number: numbersOfItems,
          p: peruk,
          h: harkava,
        });
      } else {
        handleRemove(product);
      }
    }
    //eslint-disable-next-line
  }, [numbersOfItems, peruk, harkava]);

  useEffect(() => {
    const theProduct = values.find((product) => product.title === title);
    if (theProduct?.number > 0) setNumbersOfItems(theProduct.number);
    //eslint-disable-next-line
  }, [title]);

  const handleCheck = (v) => {
    if (v === "p") {
      setPeruk(!peruk);
    } else {
      setHarkava(!harkava);
    }
  };

  let itemClassName = "paidServiceSquareDiv";
  let isItemPicked = false;
  if (numbersOfItems > 0) {
    itemClassName = "paidServiceSquareDiv paidServiceSquareDivActive";
    isItemPicked = true;
  } else {
    itemClassName = "paidServiceSquareDiv";
    isItemPicked = false;
  }

  return (
    <div className={itemClassName}>
      <img
        onClick={addItem}
        className="paidServiceSquareImg"
        src={img.length ? img : null}
        alt={title}
      />
      <div id="paidServiceSquareTitle">{title}</div>
      <div className="itemDetails">
        <div className="addItemDiv">
          {isServices && (
            <>
              <div className="disassembly">
                {havePeruk ? (
                  <>
                    <input
                      type="checkbox"
                      disabled={!isItemPicked}
                      value="p"
                      onChange={(e) => handleCheck(e.target.value)}
                    />
                    <label>פירוק</label>
                  </>
                ) : null}
              </div>
              <div className="disassembly">
                {haveHarkava ? (
                  <>
                    <input
                      type="checkbox"
                      disabled={!isItemPicked}
                      value="h"
                      onChange={(e) => handleCheck(e.target.value)}
                    />
                    <label>הרכבה</label>
                  </>
                ) : null}
              </div>
            </>
          )}
        </div>
        <h1 className="addItemDiv">{numbersOfItems}</h1>

        <div className="addItemDiv">
          <button onClick={addItem} className="plusMinus">
            +
          </button>
          <button onClick={lessItem} className="plusMinus">
            -
          </button>
        </div>
      </div>
    </div>
  );
};

export default Item;
